import { Command } from 'cmdk'
import RelayIcon from '@/components/RelayIcon'
import { useResolvedHardcodedFeed } from '@/hooks/useResolvedHardcodedFeed'
import type { THardcodedFeed } from '@/types/universe'

/**
 * Single command-palette item representing a multi-source hardcoded feed entry.
 * Resolves the display name/icon and switches to the corresponding feed on click.
 */
export default function HardcodedFeedListItem({
  item,
  onSelect
}: {
  item: THardcodedFeed
  onSelect: () => void
}) {
  const { name, icon } = useResolvedHardcodedFeed(item)

  return (
    <Command.Item onSelect={onSelect}>
      {icon ? (
        <img src={icon} className="w-5 h-5 object-cover object-center rounded shrink-0" alt="" />
      ) : (
        <RelayIcon iconSize={10} className="w-5 h-5 shrink-0" />
      )}
      <span>{name}</span>
    </Command.Item>
  )
}
